import React, { useState, useEffect } from 'react';
import Table from '../../Components/table';
import Paginations from '../../Components/Pagination/pagination';
import useLoading from "../../hooks/useLoading";
import { NotificationManager } from 'react-notifications';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { apiGetDatoTecnico, apiCreateDatoTecnico, apiDeleteDatoTecnico } from "../../lib/apiAdmin";

const DatoTecnico = () => {

    const [filters, setFilters] = useState({ page: 1, limit: 10, search: "" });
    const [results, setResults] = useState({
        "count": 0,
        "rows": []
    });
    const [form, setForm] = useState({
        "id": null,
        "descripcion": null
    });
    const [showCreate, setShowCreate] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [id2Delete, setId2Delete] = useState(null);

    const handleCloseCreate = () => {
        setShowCreate(false);
        setForm({
            "id": null,
            "descripcion": null
        });
    };

    const handleShowCreate = () => setShowCreate(true);

    const handleCloseConfirm = () => setShowConfirm(false);

    const handleShowConfirm = (id) => {
        setId2Delete(id);
        setShowConfirm(true);
    };

    const handleFormChanges = (name, e) => {
        setForm({ ...form, [name]: e.target.value });
    };

    const columns = ["ID", "Descripción", "Actividades asignadas", ""];

    const loading = useLoading();

    const changeSearch = (e) => {
        setFilters({ ...filters, search: e.target.value });
    }

    const paginationHandleClick = (page) => {
        setFilters({ ...filters, page });
    }

    const limitChange = (limit) => {
        setFilters({ ...filters, limit });
    }

    const createDatoTecnico = () => {
        loading.set();
        apiCreateDatoTecnico(form)
            .then((response) => {
                if (response.error) {
                    NotificationManager.error('Algo falló, favor de intentar más tarde.', '', 5000);
                } else {
                    NotificationManager.success('Dato técnico creado correctamente.', '', 5000);
                    setShowCreate(false);
                    setForm({
                        "id": null,
                        "descripcion": null
                    });
                    getLstDatoTecnico();
                }
                loading.stop();
            })
            .catch();
    };

    const deleteDatoTecnico = () => {
        loading.set();
        apiDeleteDatoTecnico({ id: id2Delete })
            .then((response) => {
                if (response.error) {
                    NotificationManager.error('Algo falló, favor de intentar más tarde.', '', 5000);
                } else {
                    NotificationManager.success('Dato técnico eliminado correctamente.', '', 5000);
                    setShowConfirm(false);
                    setId2Delete(null);
                    getLstDatoTecnico();
                }
                loading.stop();
            })
            .catch();
    };

    const getLstDatoTecnico = () => {
        apiGetDatoTecnico(filters)
            .then(response => {
                for (let dato of response.rows) {
                    if (dato.total_actividades < 1) {
                        dato.options = <div className='text-right'><button className="btn btn-lgt btn-danger" onClick={() => handleShowConfirm(dato.id)}><i className="fas fa-trash" /></button></div>
                    } else {
                        dato.options = <div className='text-left'></div>
                    }
                }
                setResults(response);
            })
            .catch(error => {
                console.error("ERROR en getDatoTecnico", error);
            })
    };

    useEffect(() => {
        getLstDatoTecnico();
    }, [filters]);

    return (
        <div className='mt-3'>
            <div className="card separate">
                <div className="card-body">
                    <div className="mb-3 form-inline">
                        <div className='col-md-6'>
                            <input className="form-control limit" placeholder="Escriba nombre para filtrar" style={{ width: "100%" }} value={filters.search} onChange={changeSearch} />
                        </div>
                        <div className='col-md-6 text-right'>
                            <button
                                className="btn btn-success"
                                onClick={handleShowCreate}
                            >
                                <i className="fas fa-plus" /> Crear dato técnico
                            </button>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <Table
                            columns={columns}
                            data={results.rows}
                            tableClass="table table-striped separate"
                        />
                    </div>
                </div>
                <Paginations
                    total={results.count}
                    page={filters.page}
                    limit={filters.limit}
                    pageClick={paginationHandleClick}
                    showLimit={true}
                    limitOption={[10, 25, 100]}
                    limitChange={limitChange}
                />
            </div>
            <Modal show={showCreate} onHide={handleCloseCreate} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Crear dato técnico</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label for="id">ID</label>
                        <input type="number" className="form-control" id="id" value={form.id} onChange={(value) => handleFormChanges("id", value)} />
                    </div>
                    <div className="form-group">
                        <label for="descripcion">Descripción</label>
                        <input type="text" className="form-control" id="descripcion" value={form.descripcion} onChange={(value) => handleFormChanges("descripcion", value)} />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={createDatoTecnico} disabled={!form.id || !form.descripcion}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showConfirm} onHide={handleCloseConfirm} centered>
                <Modal.Header>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Estás seguro de querer eliminar este dato técnico?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirm}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={deleteDatoTecnico}>
                        Aceptar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DatoTecnico;
